import { render } from "./Home_SocialPosts.vue?vue&type=template&id=17315ff8&scoped=true&lang=pug"
import script from "./Home_SocialPosts.vue?vue&type=script&lang=js"
export * from "./Home_SocialPosts.vue?vue&type=script&lang=js"

import "./Home_SocialPosts.vue?vue&type=style&index=0&id=17315ff8&scoped=true&lang=css"

import exportComponent from "C:\\Users\\USER\\freemath\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17315ff8"]])

export default __exports__